import { type ComponentType, lazy } from 'react';

type ComponentName<T extends Record<string, any>> = { [K in keyof T]: T[K] extends ComponentType<any> ? K : never }[keyof T];

export function makeLazy<T extends Record<string, any>, N extends ComponentName<T>>(load: () => Promise<T>, componentName: N) {
    return lazy(async () => {
        const importResult = await load();
        const Component = importResult[componentName];
        return { default: Component };
    });
}
